import React from 'react';
import Link from '@mui/material/Link';

const LinkButton = ({ 
  href, 
  children, 
  sx = {},
  style,
  className,
  ...props 
}) => {
  const defaultStyles = {
    backgroundColor: 'white',
    color: '#243B7F',
    fontWeight: 400,
    px: 4,
    py: 1.5,
    borderRadius: '5px',
    textTransform: 'none',
    fontSize: { xs: '0.9rem', md: '1rem' },
    textDecoration: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-block',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      transform: 'translateY(-2px)',
    },
    transition: 'all 0.3s ease',
  };

  return (
    <Link
      component={'a'}
      href={href}
      className={className}
      style={style}
      sx={{
        ...defaultStyles,
        ...sx, 
      }}
      {...props}
    >
      {children}
    </Link>
  );
};

export default LinkButton;
